/**
 * Builds the complete {@link PagerLabels} map from the shared `pagination.*` namespace.
 *
 * `overrides` exists because a handful of surfaces scope their pagination copy to their own
 * namespace (`campaignDetail.audience.segments.pagination.*`); without it they could not adopt
 * this builder and would keep hand-listing props — which is the failure the builder prevents.
 *
 * Call inside a `computed` so the labels follow a locale change:
 * `const pagerLabels = computed(() => buildPagerLabels(t));`
 *
 * `goToPageErrorLabel` is built only when `context` is passed: it switches the Pager's go-to-page refusal from a
 * red border cleared after 1.5 s to a message kept until the next keystroke (see `PagerProps.goToPageErrorLabel`),
 * a change of behaviour each call site opts into. `context.totalPages`, when known, puts the valid range in that
 * message (« … entre 1 et 7 », WCAG 3.3.3); unknown, the message only says the page does not exist.
 *
 * Sibling of {@link buildTableLabels} and {@link buildColumnSettingsLabels}.
 */
export function buildPagerLabels(t, overrides, context) {
    return {
        previousLabel: t("pagination.previous"),
        nextLabel: t("pagination.next"),
        rowsPerPageLabel: t("pagination.rowsPerPage"),
        itemsCountSeparator: t("pagination.of"),
        goToPageLabel: t("pagination.goToPage"),
        goLabel: t("pagination.go"),
        ...(context && {
            goToPageErrorLabel: context.totalPages === undefined
                ? t("pagination.goToPageError")
                : t("pagination.goToPageOutOfRange", { max: Math.max(context.totalPages, 1) }),
        }),
        navLabel: t("pagination.label"),
        ...overrides,
    };
}
